<script setup lang="ts">

import type {InputField} from "~/constants/types/serviceInputs";

const props = defineProps<{
  field: InputField
}>();
if (!props.field.option){
  props.field.option = props.field.options.find((option)=>option.option_id === props.field.default_value)?.option ;
}
const handleSelect = (id: string,option:string) => {
  props.field.default_value = id;
  props.field.option=option;
};
watch(useStoreSelectedServiceId(),()=>{
  props.field.option = props.field.options.find((option)=>option.option_id === props.field.default_value)?.option ;
},{immediate:true})
const selected = computed(() => props.field.default_value);
</script>

<template>
  <div>
    <div class="flex flex-wrap flex-row md:gap-1 gap-2">
      <p  v-for="option in field.options"
          class="text-sm font-medium rounded-full py-2 px-6 cursor-pointer appearance-none border focus:outline-none focus:shadow-outline "
          :class="selected == option.option_id ? 'bg-primary-green bg-opacity-5 border-primary-green' : 'border-neutral-light-gray'"
          @click="handleSelect(option.option_id,option.option)"
      >
        {{ option.option }}
      </p>
    </div>
  </div>
</template>

<style scoped>

</style>